import imagesLoaded from "imagesloaded";

import { initGalleryExperience } from "./gallery.js";

imagesLoaded(document.body, () => {
  document.body.classList.remove("loading");
  initGalleryExperience();
});
